import React, { createContext, useContext, useEffect, useState } from "react";

export const THEMES = [
  { id: "industrial_core", name: "Industrial Core", hint: "Claro / Naranja" },
  { id: "voltage_dark", name: "Voltage Dark", hint: "Oscuro" },
  { id: "warehouse_sand", name: "Warehouse Sand", hint: "Cálido" },
  { id: "blueprint", name: "Blueprint", hint: "Azul técnico" },
  { id: "high_contrast", name: "Alto Contraste", hint: "Brutalista" },
  { id: "emerald_grid", name: "Emerald Grid", hint: "Oscuro / Verde" },
  { id: "copper_dusk", name: "Copper Dusk", hint: "Oscuro / Cobre" },
  { id: "arctic_light", name: "Arctic Light", hint: "Claro / Azul hielo" },
];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("selec_theme") || "industrial_core");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "industrial_core") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", theme);
    localStorage.setItem("selec_theme", theme);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
